import type { InjectionKey, Ref } from 'vue'

const InjectionKeysMap = {
  HOME_MAIN: 'HOME_MAIN'
}

export const HOME_MAIN = Symbol(InjectionKeysMap.HOME_MAIN) as InjectionKey<
  Ref<HTMLElement | undefined>
>
